import { render, staticRenderFns } from "./TenantCode.vue?vue&type=template&id=1b01321c&"
import script from "./TenantCode.vue?vue&type=script&lang=js&"
export * from "./TenantCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports